<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="id ? '编辑账号' : '创建账号'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 账号名称 -->
      <a-form-item
        label="账号名称"
        name="name"
        :rules="[{ required: true, message: '请输入'  }]"
      >
        <a-input
          class="form-input"
          placeholder="请输入"
          v-model:value="formState.name"
          maxlength="20"
        />
      </a-form-item>
      <!-- 媒体 -->
      <a-form-item
        label="媒体"
        name="type"
        :rules="[{ required: true, message: '请选择'  }]"
      >
        <a-select
          class="form-input"
          placeholder="请选择"
          v-model:value="formState.type"
        >
          <a-select-option v-for="item in AccountChannelTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 属性 -->
      <a-form-item
        label="属性"
        name="attr_type"
        :rules="[{ required: true, message: '请选择'  }]"
      >
        <a-select
          class="form-input"
          placeholder="请选择"
          v-model:value="formState.attr_type"
        >
          <a-select-option v-for="item in AccountTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 账号成本 -->
      <a-form-item
        label="账号成本"
        name="cost"
      >
        <a-input-number
          class="form-input"
          placeholder="请输入"
          v-model:value="formState.cost"
        />
      </a-form-item>
      <!-- 变现类型 -->
      <a-form-item
        label="变现类型"
        name="cash_type"
        :rules="[{ required: true, message: '请选择'  }]"
      >
        <a-select
          class="form-input"
          placeholder="请选择"
          v-model:value="formState.cash_type"
        >
          <a-select-option v-for="item in ProfitTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 创建/购入日期 -->
      <a-form-item
        label="创建/购入日期"
        name="date"
        :rules="[{ required: true, message: '请选择'  }]"
      >
        <a-date-picker
          class="form-input"
          v-model:value="formState.date"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import { AccountTypes, ProfitTypes, AccountChannelTypes } from '@/utils/constant'
import { accountSave } from '@/api/copyright'
import dayjs from 'dayjs'

// emit
const emit = defineEmits(['success'])
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// id
let id = ref(null)
// 表单
let formState = reactive({
  // 名称
  name: undefined,
  // 媒体
  type: undefined,
  // 属性
  attr_type: undefined,
  // 账号成本
  cost: undefined,
  // 变现类型
  cash_type: undefined,
  // 创建/购入日期
  date: undefined
})

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // 赋值
  nextTick(() => {
    if (!!params.id) {
      // id
      id.value = params.id
      formState.name = params.name
      formState.type = params.type
      formState.attr_type = params.attr_type
      formState.cost = params.cost
      formState.cash_type = params.cash_type
      formState.date = params.date ? dayjs(params.date) : undefined
    }
  })
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    // 重置
    RefForm.value.resetFields()
    id.value = undefined
    visible.value = false
    formState.name = undefined
    formState.type = undefined
    formState.attr_type = undefined
    formState.cost = undefined
    formState.cash_type = undefined
    formState.date = undefined
  }
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    const params = {
      id: id.value,
      ...formState,
      date: formState.date.format('YYYY-MM-DD')
    }
    accountSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        // 更新父组件
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-input {
  width: 100%;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  position: relative;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.upload-item-select {
  position: absolute;
  right: 8px;
  bottom: 8px;
}
.upload-item-delete {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 18px;
  color: #8D8D8D;
  cursor: pointer;
  opacity: 0;
}
.form-upload-item:hover .upload-item-delete {
  opacity: 1;
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>